export const QueryKey = {
	content: 'public/content',
} as const;

export type QueryKey = (typeof QueryKey)[keyof typeof QueryKey];
